
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  ref,
  toRef,
  toRefs,
  watch,
} from "vue";
import { IBulkDelete } from "@/interfaces/iPageModel";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { TranslationService } from "@/core/services/TranslationService";
import { SUB_PAGINATION } from "@/helpers/pagination";
import { FormatMethods } from "@/helpers/data-format";
import { UserAPI } from "@/services/api/User.service";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import {
  userSiteTableBulkDelete,
  userRoleTableHeaders,
} from "../dataTableOptions";
import { IUser, IUserRoleModel } from "@/interfaces/iUser";

export default defineComponent({
  name: "UserRole",
  props: {
    data: { type: Object as PropType<IUser>, required: true },
  },
  components: { Datatable, VZDeleteModal },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const dataProp = toRef(props, "data");
    const localPageReactive = reactive(SUB_PAGINATION);
    const { page, total, rowsPerPage } = toRefs(localPageReactive);
    const loading = ref(false);
    const defaultFilter = ref({ status: "ACTIVE" });
    const showDeleteDialog = ref<any>(false);
    const showSearch = true;
    const tableData = ref<IUserRoleModel[]>([]);
    const selectedForAction = ref<Partial<IUserRoleModel>>({});
    const localPreference = ref({});
    const bulkDelete = ref<IBulkDelete>(userSiteTableBulkDelete());
    const tableHeader = ref(userRoleTableHeaders());
    const tableFilter = ref({});
    const format = computed(() => {
      return FormatMethods;
    });

    const syncQuery = async (params?: Record<string, number | string>) => {
      queryUpdate(dataProp.value.webId, params);
    };

    const queryUpdate = async (
      webId: number,
      params?: Record<string, number | string>
    ) => {
      try {
        loading.value = true;
        const data = await UserAPI.getInstance().getUserRoles({
          ...params,
          userId: dataProp.value.webId,
        });
        localPreference.value = { ...params };
        tableData.value = [...data.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } finally {
        loading.value = false;
      }
    };
    const refreshList = () => {
      showDeleteDialog.value = false;
      queryUpdate(dataProp.value.webId, { ...localPreference.value });
    };
    watch(
      dataProp,
      (newValue) => {
        tableData.value = [];
        defaultFilter.value = { ...defaultFilter.value };
        queryUpdate(+newValue, {
          ...defaultFilter.value,
          page: page.value - 1,
          size: rowsPerPage.value,
        });
      },
      { deep: true }
    );
    return {
      bulkDelete,
      format,
      tableData,
      tableHeader,
      tableFilter,
      showSearch,
      page,
      total,
      rowsPerPage,
      defaultFilter,
      loading,
      selectedForAction,
      syncQuery,
      refreshList,
      t,
      SUB_PAGINATION,
      showDeleteDialog,
    };
  },
});
